/* unplugin-vue-components disabled */import { render } from "./SupPoolWithdraw.vue?vue&type=template&id=1980cff4"
import script from "./SupPoolWithdraw.vue?vue&type=script&lang=js"
export * from "./SupPoolWithdraw.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__